export default (state = '', action = {}) => {
    if (action.type === 'EXAM_FILTER_CHANGE') {
        return action.payload;
    }
    return state;
};